export const playerSessionKeys = {
  all: ['playerSession'] as const,
  sessionList: 'list',
  summaryList: 'summary',
  list: (featureKey: string) => (request: playerSession.SortFilterSearchSessionsRequest) =>
    [
      ...playerSessionKeys.all,
      featureKey,
      request.sessionId,
      request.sort,
      request.search ?? null,
      request.levelFilter ?? null,
      request.filterInactiveFor ?? null,
      request.pagination,
      request.resultsPerPage ?? null,
      request.expectedPage ?? null,
    ] as const,
  updatePlayerProgress: (request: playerSession.UpdatePlayerProgressRequest) =>
    [
      ...playerSessionKeys.all,
      'updatePlayerProgress',
      request.sessionId ?? null,
      request.playerId,
    ] as const,
  checkSessionForPlayerProgress: (request: playerSession.CheckSessionForPlayerProgressRequest) =>
    [
      ...playerSessionKeys.all,
      'checkSessionForPlayerProgress',
      request.sessionId ?? null,
      request.playerId,
      request.checkpointMapping,
    ] as const,
} as const;
